import React, { useEffect } from "react";
import LandingCard from "../landingCard/LandingCard";
import "./Landing.css";
import { Grid } from "@mui/material";
import { useLoaderData, useNavigate } from "react-router-dom";

const LandingPage = () => {
  const navigate = useNavigate();
  const loaderData = useLoaderData();
  // Log loader data and current path for debugging route/loader issues
  console.log(
    "LandingPage loaderData:",
    loaderData,
    "pathname:",
    window.location.pathname
  );

  useEffect(() => {
    const onBack = () => {
      navigate("/", { replace: true });
    };

    window.addEventListener("popstate", onBack);
    return () => window.removeEventListener("popstate", onBack);
  }, [navigate]);

  // Use loader data when available, otherwise fall back to an empty array
  const cardsData = loaderData || [];

  const handleCardClick = (title) => {
    // debugger;
    // if ( title === 'Supply Planning' )
    //   navigate( '/supply-planning' )
    // else if ( title === 'Inventory Optimization' )
    //   navigate( '/inventory-optimization' )
    if (title === "KPI Metrics") {
      navigate("/kpi-metrics");

    }
  }

  return (
    <div className="landing-content">
      {window.location.pathname === "/inventory-optimization" &&
        <p style={{ textAlign: 'left', width: "50px", height: "30px", marginLeft: 10, marginTop: 30, cursor: 'pointer' }} onClick={() => navigate("/")}>Home</p>
      }
      <div className="Landing-main">

        {/* <h3 style={{ marginBottom: "2rem", fontWeight: "normal", fontSize: "1.25rem" }}>Select the app to launch</h3> */}
        <Grid container className="landing_cards_cls" sx={{ my: 1 }}>
          {" "}
          {cardsData?.map((data) => {
            // if (data.title === 'User Access Management' && process.env.REACT_APP_ENV === 'prod')
            //   return null;
            return (
              <Grid key={data.id} size={{ xs: 4 }}>
                <LandingCard
                  title={data.title}
                  appCode={data.appCode}
                  url={data.url}
                  className={data.className}
                  disabled={data.disabled}
                  onClick={() => handleCardClick(data.title)}
                />
              </Grid>
            );
          })}
        </Grid>
      </div>
    </div>
  );
};

export default LandingPage;